import { MdMailOutline, MdPhone, MdPlace } from 'react-icons/md'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { Container as cont } from 'reactstrap'

const IconSize = '2.3rem'
const MailIcon = styled(MdMailOutline).attrs(props => ({
  color: theme('secondary')(props)
}))`
  height: ${IconSize};
  width: ${IconSize};
`

const PhoneIcon = styled(MdPhone).attrs(props => ({
  color: theme('secondary')(props)
}))`
  height: ${IconSize};
  width: ${IconSize};
`

const PlaceIcon = styled(MdPlace).attrs(props => ({
  color: theme('secondary')(props)
}))`
  height: ${IconSize};
  width: ${IconSize};
`

const Container = styled(cont)`
  position: relative;
  z-index: 1;
  margin: 60px auto;
`

const Description = styled.p`
  margin: 20px 0 15px;
`

const Form = styled.div`
  padding: 25px;
  border: 1px solid ${theme('light')};
  border-radius: 5px;
  width: 100%;
  z-index: 20;
  background: ${theme('white')};
  -webkit-box-shadow: 20px 20px 20px 0px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 20px 20px 20px 0px rgba(0, 0, 0, 0.16);
  box-shadow: 20px 20px 20px 0px rgba(0, 0, 0, 0.16);
`

const InfoBox = styled.p`
  display: flex;
  align-items: center;
  position: relative;
  height: 64px;
  margin: 0;
  a {
    color: ${theme('secondary')};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`

const InfoText = styled.span`
  margin-left: 0.7rem;
  font-weight: 700;
  font-size: 1.5em;
`

export {
  MailIcon,
  PhoneIcon,
  PlaceIcon,
  Container,
  Description,
  Form,
  InfoBox,
  InfoText
}
